/* */

export const FIELD_TYPE_NAME: number = 0;
export const FIELD_TYPE_STRING: number = 1;
export const FIELD_TYPE_COORDINATE: number = 2;
export const FIELD_TYPE_NUMBER: number = 4;
export const FIELD_TYPE_BOOLEAN: number = 5;
export const FIELD_TYPE_IMAGE: number = 6;
export const FIELD_TYPE_ZONE: number = 9;
export const FIELD_TYPE_DATE: number = 11;
export const FIELD_TYPE_TIMESTAMP: number = 24;
export const FIELD_TYPE_ATTACHMENT: number = 28;
export const FIELD_TYPE_UDF: number = 27;

/*BARCODE TYPES*/
export const BARCODE_TYPE_CODE_128: string = 'Code 218';
export const BARCODE_TYPE_UPC_A: string = 'UPC A';

/*MODULE COLORS*/
export const COLOR_PRIMARY_MODULE = "#06549e";
export const COLOR_LOCATE_ITEM_MODULE = "#0c8dd1";
export const COLOR_LOCATE_ITEM_MODULE_SUB = "#485365";
export const COLOR_CYCLE_COUNT_MODULE = "#2d7a7a";
export const COLOR_MANAGE_TAGS_MODULE = "#6a416e";
export const COLOR_IDENTIFY_TAGS_MODULE = "#094681";
export const COLOR_REPLENISHENT_MODULE = "#485365";
export const COLOR_CURRENT_STATUS = "#fff";
export const COLOR_INSTRUCTIONS = "#2F3856";
export const COLOR_APP_GENERAL = "#094681";
export const COLOR_APP_DANGER = "#f53d3d";
export const COLOR_APP_BACKGROUND_SYNC = "#f5e816";


/*STORAGE KEYS*/
export const STORAGE_CONFIGURATION_THING = "ConfigurationThing";
export const STORAGE_USER = "user";
export const STORAGE_SET_UP_MODEL = "SetupModel";
export const STORAGE_SET_UP_MODEL_TEMP = "SetupModelTemp";
export const STORAGE_READER_SOUND_LEVEL = "SoundLevel";
export const STORAGE_TIME_OFFSET = "timeOffset";


/*READER TYPE*/
export const READER_TYPE_RFID = "RFID";
export const READER_TYPE_BARCODE = "BARCODE";

/*READER MODE*/
export const READER_MODE_SINGLE = 1;
export const READER_MODE_MULTIPLE = 2;
export const READER_MODE_GEIGER = 3;
export const READER_MODE_INVENTORY = 4;


/*THING TYPES*/
export const THING_TYPE_PRODUCT_STATUS = "ProductStatus";
export const THING_TYPE_VIZIX_EVENT = "vizixEvent";
export const THING_TYPE_CONFIGURATION_THING = "ConfigurationThing";
export const THING_TYPE_FIND_ITEM_CONFIGURATION = "FindItemConfiguration ";
export const THING_TYPE_UNASSOCIATED_CONFIGURATION = "UnassociatedConfiguration";
export const THING_TYPE_READER_CONFIGURATION = "ReaderConfiguration";
export const THING_TYPE_APP_PARAMETERS_CONFIGURATION = "AppParametersConfiguration";
export const THING_TYPE_ASSOCIATION_CONFIGURATION = "AssociationConfiguration";
export const THING_TYPE_CHANGE_STATUS_CONFIGURATION = "ChangeStatusConfiguration";
export const THING_TYPE_CYCLE_COUNT_CONFIGURATION = "CycleCountConfiguration";
export const THING_TYPE_CYCLE_COUNT_IDENTIFY_ITEM_CONFIGURATION = "IdentifyItemConfiguration";

/*VIZIX EVENT UDFs*/
export const VIZIX_EVENT_UDF_ACTION = 'action';
export const VIZIX_EVENT_UDF_ACTIVITY = 'activity';
export const VIZIX_EVENT_UDF_CATEGORY = 'category';
export const VIZIX_EVENT_UDF_COUNT = 'count';
export const VIZIX_EVENT_UDF_DESCRIPTION = 'description';
export const VIZIX_EVENT_UDF_DETAIL = 'detail';
export const VIZIX_EVENT_UDF_EVENT_DATE = 'eventDate';
export const VIZIX_EVENT_UDF_EVENT_ID = 'eventId';
export const VIZIX_EVENT_UDF_EVENT_TYPE = 'eventType';
export const VIZIX_EVENT_UDF_REMOTE_SOURCE = 'remoteSource';
export const VIZIX_EVENT_UDF_SOURCE = 'source';
export const VIZIX_EVENT_UDF_STATUS = 'status';
export const VIZIX_EVENT_UDF_SUB_CATEGORY = 'subCategory';
export const VIZIX_EVENT_UDF_USER = 'user';
export const VIZIX_EVENT_UDF_USER_GROUP = 'userGroup';
export const VIZIX_EVENT_UDF_USER_TENANT = 'userTenant';

/*ITEM UDFS*/
export const VIZIX_THING_ITEM_UDF_SOURCE = 'MOBILE';

/*VIZIX EVENT IDs*/
export const VIZIX_EVENT_ID_LOGIN = '1';
export const VIZIX_EVENT_ID_LOGOUT = '2';
export const VIZIX_EVENT_ID_READER_CONNECT = '3';
export const VIZIX_EVENT_ID_CREATE_ASSOCIATION = '4';
export const VIZIX_EVENT_ID_UPDATE_ASSOCIATION = '5';
export const VIZIX_EVENT_ID_CREATE_DEFAULT_PRODUCT = '6';
export const VIZIX_EVENT_ID_RETRIEVE_CYCLE_COUNT = '7';
export const VIZIX_EVENT_ID_START_CYCLE_COUNT = '8';
export const VIZIX_EVENT_ID_END_CYCLE_COUNT = '9';
export const VIZIX_EVENT_ID_CHANGE_STATUS = '10';
export const VIZIX_EVENT_ID_PROCESSING_CYCLE_COUNT = '11';
export const VIZIX_EVENT_ID_CREATE_ENCODE_ASSOCIATION = '12';
export const VIZIX_EVENT_WRITE_TAG = '13';
export const VIZIX_EVENT_GET_SERIAL_FROM_THING_ENCODE = '14';

/* VIZIX EVENT DETAIL MESSAGE FIELDS*/
export const VIZIX_EVENT_TENANT_GROUP = 'tenantGroup';
export const VIZIX_EVENT_THING_TYPE_CODE = 'thingTypeCode';
export const VIZIX_EVENT_FACILITY = 'facility';
export const VIZIX_EVENT_MESSAGE = 'message';
export const VIZIX_EVENT_DEPARTMENT = 'Department';
export const VIZIX_EVENT_ZONE_TYPE = 'ZoneType';
export const VIZIX_EVENT_SYNC_ID = 'syncID';

/*ITEM EVENTS*/
export const ITEM_EVENT_ASSOCIATION_TAG = 'scanscanAssociate';
export const ITEM_EVENT_RE_ASSOCIATION_TAG = 'reassociation';
export const ITEM_EVENT_SCAN_ENCODE_ASSOCIATION_TAG = 'scanscanEncode';
export const ITEM_EVENT_CYCLE_COUNT = 'cyclecount';
export const ITEM_EVENT_CHANGE_STATUS = 'changestatus';
export const ITEM_EVENT_ENCODE_ASSOCIATION_TAG = 'scanscanEncode';
/*THING BRIDGE SOURCE (used in body header)*/
export const THING_BRIDGE_SOURCE_CYCLE_COUNT = 'CycleCount';
export const THING_BRIDGE_SOURCE_EVENT = 'Event';

/*ZONES REPORT CONSTANTS*/
export const ZONE_PROPERTY = 'true';
export const DEFAULT_ZONE = 'DEFAULT';

/*REPORT KEYS*/

export const KEYS_THING_TYPE_ID = "thingTypeId";
export const KEYS_THING_HEADERS = "thing.headers";
export const KEYS_ID = "id";
export const KEYS_SERIAL = "serial";


/*NAV PARAMS*/
export const NAV_PARAM_CONFIGURATION_THING = 'configurationThing';
export const NAV_PARAM_AUTO_SEARCH = 'autoSearch';
export const NAV_PARAM_BACK_TO_MENU = 'backToMenu';
export const NAV_PARAM_RETURN_PAGE = 'returnPage';
export const NAV_PARAM_LOOKUP_EPC_LIST = 'lookupEpcList';
export const NAV_PARAM_FILTERED_RESPONSE = 'filteredResponse';
export const NAV_PARAM_SELECTED_FILTERS = 'selectedFilters';
export const NAV_PARAM_SELECTED_ZONE = 'selectedZone';
export const NAV_PARAM_SELECTED_DEPARTMENT = 'selectedDepartment';
export const NAV_PARAM_SELECTED_READER = 'selectedReader';
export const NAV_PARAM_CONNECTED_TO_READER = 'connectedToReader';


/*CONFIG FOLDER*/
export const CONFIG_FOLDER_FILE = "TrackerRetail/";
export const CONFIG_FILE_NAME = 'tr.settings.1.5.json';
export const CONFIG_CREATE_CONFIGURATION_FILE = false;
export const CONFIG_VALUE_URL = 'http://kohls.vizixcloud.com';
export const CONFIG_VALUE_STORE_ID = 39;
export const CONFIG_VALUE_IS_REMEMBER_ME_ENABLED = false;
export const CONFIG_VALUE_IS_SETUP_WIZARD_ENABLED = false;
export const CONFIG_KEY_URL = 'URL';
export const CONFIG_KEY_STORE_ID = 'StoreID';
export const CONFIG_KEY_IS_REMEMBER_ME_ENABLED = 'isRememberMeEnabled';
export const CONFIG_KEY_IS_SETUP_WIZARD_ENABLED = 'isSetupWizardEnabled';


/*DEFAULT APP PROPERTIES*/
export const DEFAULT_APP_NAME = 'Tracker Retail';
export const DEFAULT_APP_VERSION = '1.7.17.1';
export const SPLASH_SCREEN_LOGS_ENABLED = false;

/*TAG TYPES*/
export enum TagType {
  EPC,
  UPC,
  SKU,
  UNKNOWN
}

/*Vizix Events Constants and Enums*/
export enum VizixEventCategory {
  NONE,
  SECURITY,
  WORKFLOW
}

export enum VizixEventSubCategory {
  NONE,
  AUTHENTICATION,
  READER,
  MANAGE_TAGS,
  CHANGE_STATUS,
  CYCLE_COUNT,
  IDENTIFY_TAG,
  FIND_ITEMS,
  UNASSOCIATED_TAGS,
  ENCODE_TAG
}

export enum VizixEventActivity {
  NONE,
  LOGIN,
  READER_CONNECT,
  LOGOUT,
  SYNC,
  CREATE_DEFAULT_PRODUCT,
  ASSOCIATION_CREATE,
  ASSOCIATION_UPDATE,
  CHANGE_STATUS,
  ENCODE_TAG
}

export enum VizixEventAction {
  NONE,
  START,
  END,
  PROCESSED,
  CONNECT,
  RETRIEVE,
  WRITE_TAG,
  GET_SERIAL_FROM_THING,
  CREATE_ENCODE_TAG
}

export enum VizixEventEventType {
  NONE,
  INFO,
  WARN,
  ERROR
}

export enum VizixEventSource {
  NONE,
  MOBILE
}

export enum VizixEventStatus {
  NONE,
  SUCCESS,
  FAILURE
}

export enum ReaderMode {
  NONE,
  MULTI,
  SINGLE,
  INVENTORY,
  GEIGER
}

export enum ErrorCode {
  REPORT_ERROR,
  SERVER_ERROR,
  UNKNOWN_ERROR
}

// Actions
export const VIZIX_EVENT_ACTION_START = "Start";
export const VIZIX_EVENT_ACTION_END = "End";
export const VIZIX_EVENT_ACTION_PROCESSED = "Processed";
export const VIZIX_EVENT_ACTION_CONNECT = "Connect";
export const VIZIX_EVENT_ACTION_RETRIEVE = "Retrieve";
export const VIZIX_EVENT_ACTION_WRITE_TAG = "Write Tag";
export const VIZIX_EVENT_ACTION_WRITE_GET_SERIAL_FROM_THING = "Get Serial from things";
export const VIZIX_EVENT_ACTION_WRITE_CREATE_ENCODE_TAG = "Create Encoded Tag";

// Activity
export const VIZIX_EVENT_ACTIVITY_ASSOCIATION_CREATE = 'Create Association';
export const VIZIX_EVENT_ACTIVITY_ASSOCIATION_UPDATE = 'Update Association';
export const VIZIX_EVENT_ACTIVITY_CREATE_DEFAULT_PRODUCT = 'Create default product';
export const VIZIX_EVENT_ACTIVITY_LOGIN = 'Login';
export const VIZIX_EVENT_ACTIVITY_LOGOUT = 'Logout';
export const VIZIX_EVENT_ACTIVITY_READER_CONNECT = 'Reader Connection';
export const VIZIX_EVENT_ACTIVITY_SYNC = 'Sync';
export const VIZIX_EVENT_ACTIVITY_CHANGE_STATUS = 'Change Status';
export const VIZIX_EVENT_ACTIVITY_ENCODE_TAG = 'Encode Tag';

// Event Type
export const VIZIX_EVENT_EVENT_TYPE_INFO = 'INFO';
export const VIZIX_EVENT_EVENT_TYPE_WARN = 'WARN';
export const VIZIX_EVENT_EVENT_TYPE_ERROR = 'ERROR';

// Category
export const VIZIX_EVENT_CATEGORY_WORKFLOW = 'Workflow';
export const VIZIX_EVENT_CATEGORY_SECURITY = 'Security';

// Sub Category
export const VIZIX_EVENT_SUB_CATEGORY_AUTHENTICATION = 'Authentication';
export const VIZIX_EVENT_SUB_CATEGORY_READER = 'Reader';
export const VIZIX_EVENT_SUB_CATEGORY_MANAGE_TAGS = 'Tag Association';
export const VIZIX_EVENT_SUB_CATEGORY_CHANGE_STATUS = 'Change Status';
export const VIZIX_EVENT_SUB_CATEGORY_CYCLE_COUNT = 'Cycle Count';
export const VIZIX_EVENT_SUB_CATEGORY_IDENTIFY_TAG = 'Identify Tag';
export const VIZIX_EVENT_SUB_CATEGORY_FIND_ITEMS = 'Find Items';
export const VIZIX_EVENT_SUB_CATEGORY_UNASSOCIATED_TAGS = 'Unassociated Tags';
export const VIZIX_EVENT_SUB_CATEGORY_ENCODE_TAGS = 'Encode Tag';

// Source
export const VIZIX_EVENT_SOURCE_MOBILE = 'MOBILE';

// Status
export const VIZIX_EVENT_STATUS_SUCCESS = 'Success';
export const VIZIX_EVENT_STATUS_FAILURE = 'Failure';

// EMPTY UDF VALUE
export const VALUE_EMPTY = '-';

// UUID
export const UUID_NOT_AVAILABLE = 'UUID not available';

// ENDPOINT MODES
export const END_POINT_MODE_THINGS = 'things';
export const END_POINT_MODE_THING_BRIDGE = 'thingBridge';

// CYCLE COUNT ITEM UPLOAD STATUS
export const UPLOAD_STATUS_PENDING_REMOVE = 'PendingRemove';
export const UPLOAD_STATUS_PENDING_UPLOAD = 'PendingUpload';

// ERROR CODES
export const NOT_FOUND = 0;
export const INVALID_FORMAT = 1;
export const SERVER_ERROR = 2;
export const BAD_REQUEST = 3;
export const UNKNOWN_ERROR = 4;
export const CONFIGURATION_ERROR = 5;
export const CYCLE_COUNT_ALREADY_UPLOADING = 6;
export const NO_INTERNET_CONNECTION = 7;

//TAG INFORMATION SOURCES

export const TAG_INFORMATION_SOURCE_POPOVER = 'popover';
export const TAG_INFORMATION_SOURCE_FIND_ITEM = 'findItem';
export const TAG_INFORMATION_SOURCE_LOOK_UP = 'lookUp';
export const TAG_INFORMATION_SOURCE_IDENTIFY_TAG = 'identifyTag';
export const TAG_INFORMATION_SOURCE_REPLENISHMENT = 'replenishment';
export const TAG_INFORMATION_SOURCE_CYCLE_COUNT = 'cycleCount';

// SIMULATOR CONSTANTS
export const SIMULATOR_READER_SOUND_LEVELS = 5;
export const SIMULATOR_READER_NAME = 'Reader Simulator';
export const SIMULATOR_READER_ADDRESS = '00:11:22:33:44:55';
export const SIMULATOR_READER_BATTERY = '85';
export const SIMULATOR_READER_MANUFACTURER = 'MOJIX Inc';
export const SIMULATOR_READER_MAX_POWER = '100';
export const SIMULATOR_READER_MIN_POWER = '0';
export const SIMULATOR_READER_MODEL = 'Reader Simulator';
export const SIMULATOR_READER_TYPE = 'MOJIX';

// RETURN PAGE FOR 'PAIR NOW' OPTION IN MODULES
export const RETURN_PAGE_ENCODE_TAGS = 'EncodeTags';
export const RETURN_PAGE_MANAGE_TAGS = 'ManageTags';
export const RETURN_PAGE_CHANGE_STATUS = 'ChangeStatus';
export const RETURN_PAGE_IDENTIFY_TAG = 'IdentifyTag';
export const RETURN_PAGE_CYCLE_COUNT = 'CycleCount';
export const RETURN_PAGE_FIND_ITEM = 'FindItem';
export const RETURN_PAGE_LOOK_UP = 'LookUp';
export const RETURN_PAGE_UNASSOCIATED_TAGS = 'UnassociatedTags';
export const RETURN_PAGE_REPLENISHMENT = 'Replenishment';


//ALL -->DEPARTMENT ZONES
export const DEPARTMENT_NAME_ALL_VALUE = "All";
export const ZONE_ALL_CODE = 0;

// PAGINATION
export const PAGE_SIZE = 15;

// CYCLE COUNT CONSTANTS
export const CYCLE_COUNT_DEFAULT_COLUMNS_LENGTH = 7;
export const CYCLE_COUNT_DEFAULT_EXTRA_COLUMNS_LENGTH = 2;

// TIME
export const TIME_OFFSET_ACCEPTABLE_DIFFERENCE: number = 5000; // 5 seconds

// ITEM THINGTYPE UDFS
export const ITEM_UDF_CYCLE_COUNT_DATE = 'CycleCountDate';
export const ITEM_UDF_ZONE = 'zone';
export const ITEM_UDF_SOURCE = 'source';
export const ITEM_UDF_USER = 'User';
export const ITEM_UDF_LAST_DETECT_TIME = 'lastDetectTime';
export const ITEM_UDF_UUID_MOBILE = 'UUIDMobile';
export const ITEM_UDF_ACTIVITY = 'VE_Activity';
export const ITEM_UDF_MOBILE_SYNC_SESSION_ID = 'MobileSyncSessionID';
export const ITEM_UDF_CATEGORY = 'VE_Category';
export const ITEM_UDF_SUB_CATEGORY = 'VE_SubCategory';
export const ITEM_UDF_TS_EDGE_IN = 'tsEdgeIn';
export const ITEM_UDF_TS_REASSOCIATED = 'Reassociated';
export const ITEM_UDF_TS_REASSOCIATED_DATE = 'ReassociatedDate';

// EPCSequenceThing THINGTYPE UDFS
export const EPC_SEQUENCE_UDF_ORIGINAL_EPC = 'OriginalEPC';
export const EPC_SEQUENCE_UDF_UPC = 'UPC';
export const EPC_SEQUENCE_UDF_ZONE = 'zone';
export const EPC_SEQUENCE_UDF_ENCODE_EPC = 'EncodedEPC';
export const EPC_SEQUENCE_UDF_WRITE_TIME = 'WriteTime';

//INPUT VALIDATIONS
export const VALIDATION_INPUT_USER = "^[A-Za-z0-9._@-]$";
export const VALIDATION_INPUT_HOST = "^[A-Za-z0-9.:_@-]$";
export const VALIDATION_INPUT_NUMBER = "^[0-9]$";
export const VALIDATION_INPUT_DEVICE_NAME =  "^[A-Za-z0-9._-]$";
export const VALIDATION_INPUT_TAG =  "^[A-Za-z0-9]$";





// WEBPACK FOOTER //
// ./src/app/app.constants.ts